import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import coursePlacholder_1 from "../../../assets/course_1.png";
import dummy_image from "../../../assets/image.png";
import LoadingSpinner from "../../../components/LoadingSpinner";
import TruncatedTextWithTooltip from "../../../components/TruncatedTextWithTooltip";
import schoolServices from "../../../services/schoolServices"; // Ensure this import is correct
import { getLanguage } from "../../../utils/getLanguage";

const AdaptedCourses = () => {
  const { t } = useTranslation();
  const lang = getLanguage();
  const [courses, setCourses] = useState([]);
  const [loadingCourses, setLoadingCourses] = useState(true);

  const getCourses = async () => {
    setLoadingCourses(true);
    try {
      const response = await schoolServices.getCoursesBySchool();
      const formattedCourses = response.courses.map((course) => ({
        image: course.image || coursePlacholder_1, // Fallback image
        name: course.course,
      }));
      setCourses([...formattedCourses, { name: "card" }]); // Adding last card
    } catch (error) {
      console.error("Error fetching courses data:", error);
    } finally {
      setLoadingCourses(false);
    }
  };

  useEffect(() => {
    getCourses();
  }, [lang]);

  if (loadingCourses) {
    return <LoadingSpinner />;
  }

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {courses.map((item, i) =>
        item.name !== "card" ? (
          <div
            key={i}
            className="flex flex-col overflow-hidden rounded-md bg-white shadow-lg transition-all hover:scale-[1.02] dark:bg-dark-surface"
          >
            <img className="h-40 w-full object-cover" src={dummy_image} alt={item?.name} loading="lazy" />
            <div className="p-5">
              <h4 className="text-sm text-gray-500 dark:text-gray-400">{t("course")}</h4>

              <TruncatedTextWithTooltip
                text={item?.name}
                maxLength={20}
                className="text-lg font-semibold text-[#842880]"
              />
            </div>
          </div>
        ) : (
          <div
            key={i}
            className="flex flex-col overflow-hidden rounded-md bg-blue-500 shadow-lg transition-all hover:scale-[1.02] dark:bg-dark-surface"
          >
            <a
              href="https://hellocode.me/courses?lang=en"
              target="_blank"
              className="cursor-pointer p-8 text-center"
            >
              <h3 className="break-words text-2xl font-extrabold leading-snug text-white">
                {t("checkout_our_courses")}
              </h3>
              <div className="mx-auto mt-2 h-1 w-16 bg-white"></div>
            </a>
          </div>
        )
      )}
    </div>
  );
};

export default AdaptedCourses;
